import { api } from "@/lib/api";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;

const toBytes = (s) => {
  const b = atob((s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(b, (ch) => ch.charCodeAt(0));
};

export async function currentSub() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush(extra = {}) {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("As notificações foram bloqueadas. Libere nas configurações do navegador do celular e tente de novo.");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/key");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.key) }));
  await api.post("/push/subscribe", { ...sub.toJSON(), ...extra });
  return sub;
}

export async function disablePush() {
  const sub = await currentSub();
  if (!sub) return;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
}

let ctx;
export function unlockAudio() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch { /* sem áudio */ }
}

const SOUNDS = {
  pedido: { type: "triangle", notes: [[988, 0], [784, 0.32], [988, 0.8], [784, 1.12]], len: 0.45, peak: 0.9, vibrate: [400, 150, 400] },
  garcom: { type: "sine", notes: [[1046, 0], [1318, 0.18]], len: 0.3, peak: 0.7, vibrate: [200, 100, 200] },
  liberacao: { type: "sine", notes: [[880, 0], [880, 0.35], [880, 0.7]], len: 0.28, vibrate: [400, 150, 400, 150, 400] },
  aprovado: { type: "sine", notes: [[660, 0], [880, 0.14], [1320, 0.28]], len: 0.18, vibrate: [150, 80, 150] },
  recusado: { type: "square", notes: [[330, 0], [220, 0.4]], len: 0.35, vibrate: [700, 200, 700] },
};

export const audioRunning = () => ctx?.state === "running";

export function ring(kind = "liberacao", vol = 1) {
  const s = SOUNDS[kind] || SOUNDS.liberacao;
  const peak = Math.max(0.001, (s.peak || (s.type === "square" ? 0.25 : 0.5)) * vol);
  try {
    unlockAudio();
    s.notes.forEach(([freq, t]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      const at = ctx.currentTime + t;
      o.type = s.type;
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, at);
      g.gain.exponentialRampToValueAtTime(peak, at + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, at + s.len);
      o.connect(g).connect(ctx.destination);
      o.start(at);
      o.stop(at + s.len + 0.02);
    });
  } catch { /* sem áudio */ }
  if (navigator.vibrate) navigator.vibrate(s.vibrate);
}
